import React from "react";
import {connect} from "react-redux";
import "moment/locale/ru";
import {ResizableBox} from 'react-resizable';
import {
    setContextMenuData,
    setLoaderModalData
} from "../../../store/globalState/actionCreators/globalState_AppActionCreator";
import {contextMenuTypes} from "../../../tools/StaticTypes";
import {
    changeSortDirection, PackagesPaginationMovePage,
} from "../../../store/packages/actionCreators/package_MainTableActionCreator";
import {
    getPackageGroupsForTree,
    PackageCreateTree, SelectActivePackageNode
} from "../../../store/packages/actionCreators/package_TreeActionCreator";
import {
    handlerSearchPackages,
    updateInputsFieldPackage,
    updateInputsFieldSortingPackage
} from "../../../store/packages/actionCreators/package_InputActionCreator";
import {__} from "../../../tools/HelpFunctions";


class ThMainTablePackage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            defaultWidth: (this.props.data.Value.length * 13) + 70,
            //TODO aa - исправлен баг кнопки вписать
            width: this.props.data.Size ? this.props.data.Size : (this.props.data.Value.length * 13) + 70,
            // width : (this.props.data.Value.length * 13) + 70
        };

        this.onResize = this.onResize.bind(this);
        this.getCurrentSearchInputs = this.getCurrentSearchInputs.bind(this);
        this.search = this.search.bind(this)
    }

    onResize = (event, {element, size, handle}) => {
        this.setState({width: size.width});
        this.props.setItemSize(size.width);
        this.props.setWidth(size.width);
    };


    componentDidMount() {
        this.props.setWidth(0);
        this.props.setItemSize(0);
        this.setState({width: (this.props.data.Value.length * 13) + 70})
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let lSize = this.props.data.Size ? this.props.data.Size : (this.props.data.Value.length * 13) + 70;

        if (prevProps.data.Size != this.props.data.Size)
            this.setState({width: lSize})
    }

    getCurrentSearchInputs() {
        let searchInputs;

        if (this.props.tableRole === "main") {
            searchInputs = this.props.searchInputsMain
        } else if (this.props.tableRole === "additional") {
            searchInputs = this.props.searchInputsAdditional
        } else if (this.props.tableRole === "download") {
            searchInputs = this.props.searchInputsDownload
        }

        return searchInputs;
    }

    async search() {
        this.props.setLoaderModalData({
            data: {
                content: "Загрузка...",
                disableButton: true,
                fullBackground: true,
                gif: "packages",
                key: "ThMainTable6963"
            }
        });
        let sortedParams;
        if (this.props.tableRole == "main") {
            sortedParams = this.props.sortedParamsMain
        } else if (this.props.tableRole == "additional") {
            sortedParams = this.props.sortedParamsAdditional
        } else if (this.props.tableRole == "download") {
            sortedParams = this.props.sortedParamsDownload
        }
        let Value
        if (this.props.data.Name !== "Version.ModifyTime" && this.props.data.Name !== "Version.Version") {
            Value = (sortedParams[this.props.data.Name] % 2) +1
        } else if (this.props.data.Name === "Version.ModifyTime"){
            Value = (sortedParams["ModifyDate"] % 2) + 1
        }
        let SortingParam = this.props.data.Name !== "Version.ModifyTime" ? this.props.data.Name : "ModifyDate"
        this.props.updateInputsFieldSortingPackage({TableRole: this.props.tableRole, SortingParam, Direction: Value})
        this.props.changeSortDirection({dir: !this.props.sortDir, sortField: this.props.data})

        let searchInputs = this.getCurrentSearchInputs()
        this.props.updateInputsFieldPackage({
            TableRole: this.props.tableRole,
            IsSearch: searchInputs.IsSearch,
            RegDateAsString: searchInputs.RegDateAsString ?? {ApproximatelyEqual: '', OnDate: '', DateStart: '', DateEnd: ''},
            RegDatePackAsString: searchInputs.RegDatePackAsString ?? {ApproximatelyEqual: '', OnDate: '', DateStart: '', DateEnd: ''},
            RegNumber: searchInputs.RegNumber ?? {ApproximatelyEqual: '', BeginningFrom: '', EndingOn: '', Equal: ''},
            Name: searchInputs.Name ?? {ApproximatelyEqual: '', BeginningFrom: '', EndingOn: '', Equal: ''},
            NamePack: searchInputs.NamePack ?? {ApproximatelyEqual: '', BeginningFrom: '', EndingOn: '', Equal: ''},
            TypeName: searchInputs.TypeName ?? {In: ''},
            ModifyDate: searchInputs.ModifyDate ?? {ApproximatelyEqual: '', OnDate: '', DateStart: '', DateEnd: ''},
            ModifyDatePack: searchInputs.ModifyDatePack ?? {ApproximatelyEqual: '', OnDate: '', DateStart: '', DateEnd: ''},
            AppliedParams: searchInputs.AppliedParams,
            Next: {
                action: async () => {
                    await this.props.PackagesPaginationMovePage({
                        PageNumber: 1,
                        TableType: this.props.tableRole,
                        FieldSorting: SortingParam,
                        Direction: Value,
                        Next: {
                            action: async () => {
                                __.deleteDocFromLinkUsingActiveNode(this.props.tableRole);
                                this.props.setLoaderModalData({keyDeleted: "ThMainTablePackage123"})
                            },
                            params: {}
                        }
                    });
                }
            }
        })
    }

    rightClick(event, item) {
        this.props.setContextMenuData({
            name : contextMenuTypes.MainTablePackageTH,
            data : {
                tableRole: this.props.tableRole,
                th : this.props.data
            },
            position : {
                x : event.clientX,
                y : event.clientY}
        });
        event.preventDefault();
    }


    render() {

        let width = {
            width: this.state.width + "px", // TODO: Подобрать норм размеры изначальные (тут пока на глаз сделал)
            position: "relative",
            paddingLeft: "0px",
        }
        let styleSpan = {
            marginRight: "20px",
        }
        let styleI = {
            verticalAlign: "middle",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        }

        //TODO БАГ. Фильтры в Пакетах при открытой доп таблице

        const {data} = this.props;

        let searchInputs;
        let sortedParams;

        if (this.props.tableRole == "main") {
            searchInputs = this.props.searchInputsMain
            sortedParams = this.props.sortedParamsMain
        } else if (this.props.tableRole == "additional") {
            searchInputs = this.props.searchInputsAdditional
            sortedParams = this.props.sortedParamsAdditional
        } else if (this.props.tableRole == "download") {
            searchInputs = this.props.searchInputsDownload
            sortedParams = this.props.sortedParamsDownload
        }

        let iconClass="icon-Filter fsic"

        if (this.props.data.Name !== "Version.ModifyTime" && this.props.data.Name !== "Version.Version") {
            const curParam = sortedParams[this.props.data.Name]
            if (curParam !== 0) {
                iconClass = curParam === 1 ? "icon-Filter_down" : "icon-Filter_up"
            }
        } else if (this.props.data.Name === "Version.ModifyTime") {
            const curParam = sortedParams["ModifyDate"]
            if (curParam !== 0) {
                iconClass = curParam === 1 ? "icon-Filter_down" : "icon-Filter_up"
            }
        }

        let colorStyle = "icon-color-original";
        let colorText = "";
        if (searchInputs) {
            let isFilter = false;
            for (let key in searchInputs) {
                if (
                    this.props?.data &&
                    key === this.props.data.Name &&
                    searchInputs.AppliedParams &&
                    searchInputs.AppliedParams[key]
                ) {
                    isFilter = true;
                }

                if (
                    key === "ModifyDate" &&
                    data &&
                    data.Name === "Version.ModifyTime" &&
                    searchInputs.AppliedParams &&
                    searchInputs.AppliedParams[key]
                ) {
                    isFilter = true;
                } else if (
                    key === "ModifyDatePack" &&
                    data &&
                    data.Name === "Version.ModifyTime" &&
                    searchInputs.AppliedParams &&
                    searchInputs.AppliedParams[key]
                ) {
                    isFilter = true;
                } else if (
                    key === "RegDateAsString" &&
                    data?.Name === "RegDate" &&
                    searchInputs.AppliedParams &&
                    searchInputs.AppliedParams[key]
                ) {
                    isFilter = true;
                } else if (
                    key === "RegDatePackAsString" &&
                    data?.Name === "RegDate" &&
                    searchInputs.AppliedParams &&
                    searchInputs.AppliedParams[key]
                ) {
                    isFilter = true;
                } else if (
                    key === "NamePack" &&
                    data?.Name === "Name" &&
                    searchInputs.AppliedParams &&
                    searchInputs.AppliedParams[key]
                ) {
                    isFilter = true;
                }
            }

            //TODO Костыль был
            // if(this.props.tableRole === "main") {
            if (isFilter) {
                colorStyle = "icon-color-secondary";
                colorText = "text-color-secondary";
            }
            // }
        }
        if (this.props.data.Name !== "Version.Version") {
            return (
                <th className="i2color"
                    onContextMenu={(event) => {this.rightClick(event)}}
                    style={width}
                    title={this.props.data.Value}>
                    <ResizableBox style={{display: "inline-block"}}
                                  width={this.state.width}
                                  height={0}
                                  onResize={this.onResize}
                                  minConstraints={[this.state.defaultWidth / 2.5, 0]}
                                  maxConstraints={[this.state.defaultWidth * 3, 0]}
                                  axis={'x'}
                                  handle={(h, ref) => <span style={{
                                      cursor: "col-resize",
                                      position: "absolute",
                                      right: 0,
                                      width: "24px",
                                      background: "#fff",
                                      height: "24px"
                                  }} ref={ref}><i className={"svg-icon icon-Doc_view_2"}/></span>}
                    >
                            <span style={styleSpan}>
                              <span style={styleI}>  <i
                                  className={`svg-icon ${colorStyle} svg-icon-sm ${iconClass}`}> </i></span>&nbsp;&nbsp;
                                <span className={colorText} role="button"
                                      onClick={(event) => this.search()}
                                >
                                    {this.props.data.Value}
                                </span>
                            </span>
                    </ResizableBox>
                </th>
            );
        } else return null;
    }
}


const mapStateToProps = state => {
    return {
        activeNode: state.packages.tree.activeNode,
        activeNodeAdditional: state.packages.treeAdditional.activeNode,
        activeNodeDownload: state.packages.treeDownload.activeNode,
        activeNodeId: state.packages.tree.activeNode.Node.Id,
        changeViewModeSearch: state.document.rootState.viewModeSearch,
        pageSize: state.packages.mainTable.paginationPageSize,
        searchInputsAdditional: state.packages.treeAdditional.searchInputs,
        searchInputsDownload: state.packages.treeDownload.searchInputs,
        searchInputsMain: state.packages.tree.searchInputs,
        sortDir: state.packages.mainTable.sortDirection,
        sortField: state.packages.mainTable.sortField,
        sortedParamsMain: state.packages.tree.SortedParams,
        sortedParamsAdditional: state.packages.treeAdditional.SortedParams,
        sortedParamsDownload: state.packages.treeDownload.SortedParams,
    }
}

const mapDispatchToProps = {
    changeSortDirection,
    handlerSearchPackages,
    PackageCreateTree,
    PackagesPaginationMovePage,
    updateInputsFieldPackage,
    updateInputsFieldSortingPackage,
    setLoaderModalData,
    SelectActivePackageNode,
    getPackageGroupsForTree,
    setContextMenuData
}

export default connect(mapStateToProps, mapDispatchToProps)(ThMainTablePackage);
